// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"src_app_modules_user_user_module_ts":"7fa329c3fc29002e","src_app_modules_vaitsn_pages_users_users_module_ts":"11280599c6416d3b"}[chunkId] + ".js";
};